import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../environments/environment';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient) { }

  // jwt() {
  //   // create authorization header with jwt token
  //   let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //   if (currentUser && currentUser.token) {
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + currentUser.token });
  //     return new RequestOptions({ headers: headers });
  //   }
  // }

  getToken(){
    // create authorization header with jwt token
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      return currentUser.token
    }
    return null
  }
  getReleaseId(){
    let agentId = localStorage.getItem("agent_id");
    let currentRelease = JSON.parse(localStorage.getItem('release'));
  
    if(currentRelease && currentRelease[agentId]){
      return currentRelease[agentId];
    }
    else{
      return {_id: "master", "name": "master"};
    }
  }

  login(username: string, password: string, encrypted: boolean = false, otp: string = null): Observable<any> {
    const loginData = {
      username: username,
      password: password,
      encrypted: encrypted,
      otp: otp
    };
  
    return this.http.post(environment.identity_service_api + 'auth/login', loginData)
      .pipe(
        map((response: any) => {
          // Login successful if there's a jwt token in the response
          if (response && response.token) {
            // Store user details and jwt token in local storage to keep the user logged in between page refreshes
            response.expirationTime = new Date().setHours(new Date().getHours() + parseInt(response.exp.split(":")[0]));
            localStorage.setItem('currentUser', JSON.stringify(response));
          }
          return response;
        }),
        catchError((error: any) => {
          console.error(error);
          return throwError(error);
        })
      );
  }

  logout(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));

      // Remove user from local storage
      localStorage.removeItem('currentUser');
      localStorage.removeItem('userConfig');

      // Set up HTTP headers
      const headers = new HttpHeaders().set('Authorization', `Bearer ${currentUser.token}`);

      this.http.post(environment.identity_service_api + 'auth/logout', { refresh_token: currentUser.refresh_token }, { headers })  
      .subscribe(
          () => {
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  signup(signup_details) {
    return this.http.post(environment.identity_service_api+'user/signup', JSON.stringify(signup_details))
  }

  resendConfrimationEmail(resend_details) {
    return this.http.post(environment.identity_service_api + 'user/resend', JSON.stringify(resend_details))
  }

  requestResetPassowrd(params) {
    
    return this.http.post(environment.identity_service_api + 'user/forget_password', JSON.stringify(params))
  }

  resetPassowrd(params) {
    return this.http.post(environment.identity_service_api + 'user/new_password', JSON.stringify(params))
  }

  validateToken(token) {
    return this.http.post(environment.identity_service_api + 'user/validate_token/' + token, null)
  }

  resendOTP(username: string) {
    return this.http.post(environment.identity_service_api + 'auth/resend_otp', JSON.stringify({ username: username}))
  }

  refreshToken() {
    return this.http.post(environment.identity_service_api + 'auth/refresh_auth_token', []).pipe(
      map((response: any) => {
        // login successful if there's a jwt token in the response
        if (response && response["token"]) {
          localStorage.removeItem('currentUser');
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          response['expirationTime'] = new Date().setHours(new Date().getHours() + parseInt(response.exp.split(":")[0]));
          localStorage.setItem('currentUser', JSON.stringify(response));
        }
        return response;
      }),
      catchError((err: any) => {
        console.log(err);
        return err;
      })
    );
  }

  getSSOList() {
    return this.http.get(environment.identity_service_api+'auth/sso_list')
  }


}


@Injectable()
export class AuthContextService {
  
  constructor(private _router:Router,
    public auth: AuthService,
    private modalService: NgbModal) { }

  isLoggedIn() {
    return localStorage.getItem('currentUser')!= null;
  }

  getToken(isRefreshToken = false){
    // create authorization header with jwt token
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token && isRefreshToken) {
      return currentUser.refresh_token
    } else if(currentUser && currentUser.token) {
      return currentUser.token
    }
    return null
  }

  getReleaseId(){
    let urlSegments = window.location.pathname.split("/")
    let agentId = ""
    if(urlSegments.length >= 3) {
      agentId = urlSegments[2]
    }
    // let agentId = localStorage.getItem("agent_id");
    let currentRelease = JSON.parse(localStorage.getItem('release'));
  
    if(currentRelease && currentRelease[agentId]){
      return currentRelease[agentId];
    }
    else{
      return {_id: "master", "name": "master"};
    }
  }

  logoutUser(){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("current user",localStorage.getItem('currentUser'))
    if(currentUser['sso_enable'] =='true' && environment.sso_redirect_url){
      localStorage.removeItem("currentUser");
      window.location.href = environment.sso_redirect_url  
    }else{
      this.auth.logout();
      localStorage.removeItem("currentUser");
      this.modalService.dismissAll();
      this._router.navigate(['/auth/login']);
    }
    // clear localStorage items.
    
  }

}
